/** Angular */
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
/** Directives */
import { BydFeatureFlagDirective } from './directives/byd-feature-flag.directive';
/** Configs */
import { BYD_FEATURE_FLAGS_INJECTION_TOKEN } from './configs/byd-feature-flags-injection-token';

/**
 * The beyond feature toggles module.
 *
 * @see https://github.com/sxd-platform/byd-front-libs/blob/master/projects/byd-feature-flags/README.md
 * @property forRoot
 * @module BydFeatureFlagsModule
 */
@NgModule({
  declarations: [BydFeatureFlagDirective],
  imports: [CommonModule],
  exports: [BydFeatureFlagDirective],
})
export class BydFeatureFlagsModule {
  /**
   * Use this method in the module to change the feature flags key.
   *
   * @param featureFlagsKey the feature flags key in `environment.json`
   * @example BydFeatureFlagsModule.forRoot('featureFlagsKey'),
   * @default Key 'featureFlags'
   * @returns ModuleWithProviders
   */
  static forRoot(featureFlagsKey: string): ModuleWithProviders<BydFeatureFlagsModule> {
    return {
      ngModule: BydFeatureFlagsModule,
      providers: [
        {
          provide: BYD_FEATURE_FLAGS_INJECTION_TOKEN,
          useValue: featureFlagsKey,
        },
      ],
    };
  }
}
